import { render, staticRenderFns } from "./BoysAndGirls.vue?vue&type=template&id=bb421242&scoped=true&"
import script from "./BoysAndGirls.vue?vue&type=script&lang=js&"
export * from "./BoysAndGirls.vue?vue&type=script&lang=js&"
import style0 from "./BoysAndGirls.vue?vue&type=style&index=0&id=bb421242&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb421242",
  null
  
)

export default component.exports